export function getRecentResultsInitialState() {
    return {
        results: [],
        maxLength: 10,
    };
}
